import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { SettingsService } from './core/settings/settings.service';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, InteractionStatus, RedirectRequest, PopupRequest, AuthenticationResult, EventType, AccountInfo } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { ILoginUtenteParams, UtenteService } from './shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    @HostBinding('class.layout-fixed') get isFixed() { return this.settings.getLayoutSetting('isFixed'); };
    @HostBinding('class.aside-collapsed') get isCollapsed() { return this.settings.getLayoutSetting('isCollapsed'); };
    @HostBinding('class.layout-boxed') get isBoxed() { return this.settings.getLayoutSetting('isBoxed'); };
    @HostBinding('class.layout-fs') get useFullLayout() { return this.settings.getLayoutSetting('useFullLayout'); };
    @HostBinding('class.hidden-footer') get hiddenFooter() { return this.settings.getLayoutSetting('hiddenFooter'); };
    @HostBinding('class.layout-h') get horizontal() { return this.settings.getLayoutSetting('horizontal'); };
    @HostBinding('class.aside-float') get isFloat() { return this.settings.getLayoutSetting('isFloat'); };
    @HostBinding('class.offsidebar-open') get offsidebarOpen() { return this.settings.getLayoutSetting('offsidebarOpen'); };
    @HostBinding('class.aside-toggled') get asideToggled() { return this.settings.getLayoutSetting('asideToggled'); };
    @HostBinding('class.aside-collapsed-text') get isCollapsedText() { return this.settings.getLayoutSetting('isCollapsedText'); };

    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();

    constructor(public settings: SettingsService, @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private utenteService: UtenteService, private router: Router, private route: ActivatedRoute) { }

    ngOnInit() {
        // prevent empty links to reload the page
        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            if (target.tagName === 'A' && ['', '#'].indexOf(target.getAttribute('href')) > -1)
                e.preventDefault();
        });
        this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
        //this.setLoginDisplay();
    
        // this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
        // this.msalBroadcastService.msalSubject$
        //   .pipe(
        //     filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
        //   )
        //   .subscribe((result: EventMessage) => {
        //     if (this.authService.instance.getAllAccounts().length === 0) {
        //       window.location.pathname = "/";
        //     } else {
        //       //this.setLoginDisplay();
        //     }
        //   });
        
        this.msalBroadcastService.inProgress$
          .pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            takeUntil(this._destroying$)
          )
          .subscribe(() => {
            //this.setLoginDisplay();
            this.checkAndSetActiveAccount();
          })
      }
    
      // setLoginDisplay() {
      //   console.log("ACC: ", this.authService.instance.getAllAccounts())
      //   this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
      // }
    
      checkAndSetActiveAccount() {
        /**
         * If no active account set but there are accounts signed in, sets first account to active account
         * To use active account set here, subscribe to inProgress$ first in your component
         * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
         */
        let activeAccount = this.authService.instance.getActiveAccount();
        let allAccounts = this.authService.instance.getAllAccounts();

        if (activeAccount) {
          this.setStorage(activeAccount);
        } else if (allAccounts?.length > 0) {
          this.authService.instance.setActiveAccount(allAccounts[0]);
          this.setStorage(allAccounts[0]);
        } else {
          this.router.navigate["/login"];
        }


      }

      private setStorage(account: AccountInfo) {

        localStorage.setItem("azureAccount", JSON.stringify(account));
        
        const azureToken = localStorage.getItem("azureToken");

        if (azureToken) {

          const params: ILoginUtenteParams = {
            token: azureToken
          }

          this.utenteService.login(params).subscribe(logged => { 

            if (logged) {
              const actualPath = this.route.snapshot.firstChild?.url[0]?.path;

              if (actualPath == "login") {
                this.router.navigate(["/"]);
              }
            } else {
              this.utenteService.logout();
            }

          }, err => {
            this.utenteService.logout();
          });
        }

      }

      // validaEmail() {
      //   this.utenteService.validaEmail("utenteProva@alexcorlattisoluzione1.onmicrosoft.com").subscribe(resp => {

      //     console.log("RESP:", resp);

      //   })
      // }
    
      // loginRedirect() {
      //   if (this.msalGuardConfig.authRequest){
      //     this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      //   } else {
      //     this.authService.loginRedirect();
      //   }
      // }
    
      // loginPopup() {
      //   if (this.msalGuardConfig.authRequest){
      //     this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
      //       .subscribe((response: AuthenticationResult) => {
      //         this.authService.instance.setActiveAccount(response.account);
      //       });
      //     } else {
      //       this.authService.loginPopup()
      //         .subscribe((response: AuthenticationResult) => {
      //           this.authService.instance.setActiveAccount(response.account);
      //     });
      //   }
      // }
    
      // logout(popup?: boolean) {
      //   if (popup) {
      //     this.authService.logoutPopup({
      //       mainWindowRedirectUri: "/"
      //     }).subscribe(() => {
      //       console.log("Sloggato");
      //     });
      //   } else {
      //     this.authService.logoutRedirect();
      //   }
      // }
    
      ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
      }

}